export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";